import { Action, ActionMeta, ID, RecordObject } from 'src/models/general.model';
import { AppActions } from 'src/models/interface.model';
import { TradeActions } from 'src/models/query.model';
import { TradeParams } from 'src/models';

export const requestTrade = (trade_contract_id: string): Action => ({
  type: TradeActions.SHOW,
  payload: trade_contract_id,
});

export const requestTrades = (params: TradeParams = {}, meta?: ActionMeta): Action => ({
  type: TradeActions.GET,
  payload: params,
  meta,
});

export const requestMoreTrades = (meta?: ActionMeta): Action => ({
  type: TradeActions.GET_MORE,
  meta: { isUpdate: true, ...meta },
});

export const cleanUpAfterTrades = (): Action => ({ type: AppActions.CLEANUP });

export const requestTradeCreate = (project_id: ID, data: Record<string, unknown>, meta?: ActionMeta): Action => ({
  type: TradeActions.CREATE,
  payload: { project_id, data },
  meta,
});

export const requestTradeUpdate = (payload: RecordObject, meta?: ActionMeta): Action => ({
  type: TradeActions.UPDATE,
  payload,
  meta,
});

export const requestTradeDelete = (meta?: ActionMeta): Action => ({
  type: TradeActions.DELETE,
  meta,
});
